import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllProdutoAgricolaCadastro } from '../service';
import {
  LIST_PRODUTO_AGRICOLA_CADASTRO,
  LIST_PRODUTO_AGRICOLA_CADASTRO_PENDING,
  LIST_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
  LIST_PRODUTO_AGRICOLA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllProdutoAgricolaCadastro(action) {
  yield put({ type: LIST_PRODUTO_AGRICOLA_CADASTRO_PENDING })

  try {
    const list = yield call(findAllProdutoAgricolaCadastro)
    
    yield put({ type: LIST_PRODUTO_AGRICOLA_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_PRODUTO_AGRICOLA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllProdutoAgricolaCadastro() {
  yield takeLatest(LIST_PRODUTO_AGRICOLA_CADASTRO, sagaListAllProdutoAgricolaCadastro)
}